import * as React from "react";
import { SettingsSectionLabel } from "@/components/settings/SettingsSectionLabel";
import { cn } from "@/lib/utils";

/**
 * PanelSectionLabel — the issue detail panel's section/field label. Same
 * uppercase grey treatment as the Settings pages, dropped to the issues
 * table's header metrics (10px / tracking-wide) so the panel's labels read
 * as quietly as the column headers behind it (WHA-3810 round 2).
 */
export function PanelSectionLabel({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) {
  return <SettingsSectionLabel className={cn("text-[10px] tracking-wide", className)} {...props} />;
}
